import React from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import useMediaQuery from '../../../hooks/useMediaQuery'
import ChatList from './chatList'
import ChatsDesktopView from './ChatsDesktopView'

export type ChatViewMode = 'admin' | 'observer'


const ChatListSh = (): JSX.Element => {
    const { pathname } = useLocation()
    const isDesktop = useMediaQuery('(min-width: 992px)')
    const isWithSidebar = isDesktop && pathname.startsWith('/landlord')

    const [searchParams] = useSearchParams()

    const mode: ChatViewMode =
        searchParams.get('mode') === 'observer'
            ? 'observer'
            : 'admin'



    return isWithSidebar
        ? <ChatsDesktopView mode={mode} />
        : <ChatList mode={mode} />
}

export default ChatListSh


